var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKugelTiefeLagen(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 657,
    height: 390,
    viewBox: "0 0 657 390",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#745336;}.cls-2{fill:#686868;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill:#6a8479;}.cls-8{fill:#b5c1bc;}.cls-9{fill:#938d7e;}.cls-10{fill:#cedcdd;}.cls-11{fill:#d2d0cf;}.cls-12{fill:#e0f2fd;}.cls-13{fill:#3c5056;}.cls-14{fill:#456558;}.cls-4{opacity:.22;}.cls-5{opacity:.19;}.cls-15{fill:none;stroke:#745336;stroke-miterlimit:10;}.cls-16{opacity:.62;}.cls-6{opacity:.59;}.cls-7{opacity:.56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boden"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 338.33594,
    width: 657,
    height: 31,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 78,
    y: 369.17188,
    width: 501,
    height: 20.82812,
    rx: 8.58938,
    ry: 8.58938
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "glas"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M328.5,358.01758C138.34668,358.01758,.33301,353.40088,.33301,347.04004,.33301,254.40625,34.46973,167.31787,96.45605,101.81738,158.4375,36.3208,240.8457,.25,328.5,.25s170.0625,36.0708,232.04395,101.56738c61.98633,65.50049,96.12305,152.58887,96.12305,245.22266,0,6.36084-138.01367,10.97754-328.16699,10.97754Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M328.5,.49997c44.26514,0,87.2063,9.16101,127.63062,27.22867,39.04736,17.45218,74.11621,42.43707,104.23193,74.26074,30.11768,31.82559,53.76367,68.88643,70.28125,110.15292,17.10181,42.7255,25.77295,88.11175,25.77295,134.89792,0,.0095-.07959,.96758-6.96045,2.13858-4.68311,.79692-11.68188,1.56242-20.80176,2.275-17.3269,1.354-42.35303,2.534-74.3833,3.50742-59.55908,1.80992-139.7395,2.80667-225.77124,2.80667s-166.21216-.99675-225.77124-2.80667c-32.03027-.97342-57.0564-2.15342-74.3833-3.50742-9.11987-.71258-16.11865-1.47808-20.80176-2.275-6.88086-1.171-6.96045-2.12908-6.96045-2.13858,0-46.78617,8.67114-92.17241,25.77295-134.89792,16.51758-41.26649,40.16357-78.32733,70.28125-110.15292,30.11572-31.82367,65.18457-56.80856,104.23193-74.26074C241.2937,9.66098,284.23486,.49997,328.5,.49997M328.5-.00003C147.12036-.00003,.08325,155.37521,.08325,347.04022c0,7.48513,164.20825,11.22769,328.41675,11.22769s328.41675-3.74256,328.41675-11.22769C656.91675,155.37521,509.87964-.00003,328.5-.00003h0Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "landschaft"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.41271,338.33594s148.29301-238.5,326.9542,0H193.41271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.26829,338.33594s126.35123-203.21098,278.57729,0H13.26829Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M354.4631,338.33594s111.83145-179.85879,246.56431,0h-246.56431Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M374.98686,338.33594s121.89163-203.21098,268.74484,0H374.98686Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M593.23566,307.05149c0-11.10034,20.09895-20.09895,20.09895-20.09895v40.1979s-20.09895-8.99861-20.09895-20.09895Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M633.7831,307.05149c0-11.10034-20.09895-20.09895-20.09895-20.09895v40.1979s20.09895-8.99861,20.09895-20.09895Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 616.83008,
    y1: 301.28396,
    x2: 613.68416,
    y2: 306.35239
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 608.44095,
    y1: 309.67309,
    x2: 613.68416,
    y2: 316.8388
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "613.68416 286.95254 613.68416 301.67475 613.68416 305.1388 613.68416 338.33594"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M561.23566,307.05149c0-11.10034,20.09895-20.09895,20.09895-20.09895v40.1979s-20.09895-8.99861-20.09895-20.09895Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M601.7831,307.05149c0-11.10034-20.09895-20.09895-20.09895-20.09895v40.1979s20.09895-8.99861,20.09895-20.09895Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 584.83008,
    y1: 301.28396,
    x2: 581.68416,
    y2: 306.35239
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 576.44095,
    y1: 309.67309,
    x2: 581.68416,
    y2: 316.8388
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "581.68416 286.95254 581.68416 301.67475 581.68416 305.1388 581.68416 338.33594"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.23566,307.05149c0-11.10034,20.09895-20.09895,20.09895-20.09895v40.1979s-20.09895-8.99861-20.09895-20.09895Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M90.7831,307.05149c0-11.10034-20.09895-20.09895-20.09895-20.09895v40.1979s20.09895-8.99861,20.09895-20.09895Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 73.83008,
    y1: 301.28396,
    x2: 70.68416,
    y2: 306.35239
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 65.44095,
    y1: 309.67309,
    x2: 70.68416,
    y2: 316.8388
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "70.68416 286.95254 70.68416 301.67475 70.68416 305.1388 70.68416 338.33594"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 221.95108,
    y: 201.14226,
    width: 94.54545,
    height: 137.19368
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 316.56504,
    y: 203.79048,
    width: 72.89592,
    height: 134.54545
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "274.36214 190.33594 316.56504 203.79048 316.56504 338.33594 274.36214 338.33594 274.36214 190.33594"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "389.46096 203.79048 274.36214 190.33594 316.56504 203.79048 389.46096 203.79048"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 146.93131,
    y: 197.49871,
    width: 57.91336,
    height: 140.83723,
    transform: "translate(351.77598 535.83465) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "238.37345 183.41499 204.84467 197.49871 204.84467 338.33594 238.37345 338.33594 238.37345 183.41499"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "146.93131 197.49871 238.37345 183.41499 204.84467 197.49871 146.93131 197.49871"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 352.63092,
    y: 201.14226,
    width: 83.24111,
    height: 137.19368
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 411.81274,
    y: 218.53472,
    width: 50.61265,
    height: 119.80122
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 414.37029,
    y: 218.53472,
    width: 45.49754,
    height: 16.96062
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.37029,
    y: 238.1202,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 414.91121,
    y: 239.06246,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.91121,
    y: 248.5299,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.91121,
    y: 243.79618,
    width: 8.3457,
    height: 0.33652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 432.53252,
    y: 238.1202,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 433.07345,
    y: 239.06246,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 433.07345,
    y: 248.5299,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 433.07345,
    y: 243.79618,
    width: 8.3457,
    height: 0.33652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 450.69476,
    y: 238.1202,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 451.23569,
    y: 239.06246,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.23569,
    y: 248.5299,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.23569,
    y: 243.79618,
    width: 8.3457,
    height: 0.33652
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.37029,
    y: 260.01645,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 414.91121,
    y: 260.95871,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.91121,
    y: 270.42615,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.91121,
    y: 265.69243,
    width: 8.3457,
    height: 0.33652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 432.53252,
    y: 260.01645,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 433.07345,
    y: 260.95871,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 433.07345,
    y: 270.42615,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 433.07345,
    y: 265.69243,
    width: 8.3457,
    height: 0.33652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 450.69476,
    y: 260.01645,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 451.23569,
    y: 260.95871,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.23569,
    y: 270.42615,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.23569,
    y: 265.69243,
    width: 8.3457,
    height: 0.33652
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.37029,
    y: 281.91271,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 414.91121,
    y: 282.85496,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.91121,
    y: 292.3224,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.91121,
    y: 287.58868,
    width: 8.3457,
    height: 0.33652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 432.53252,
    y: 281.91271,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 433.07345,
    y: 282.85496,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 433.07345,
    y: 292.3224,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 433.07345,
    y: 287.58868,
    width: 8.3457,
    height: 0.33652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 450.69476,
    y: 281.91271,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 451.23569,
    y: 282.85496,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.23569,
    y: 292.3224,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.23569,
    y: 287.58868,
    width: 8.3457,
    height: 0.33652
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.37029,
    y: 303.80896,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 414.91121,
    y: 304.75121,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.91121,
    y: 314.21865,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 414.91121,
    y: 309.48493,
    width: 8.3457,
    height: 0.33652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 432.53252,
    y: 303.80896,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 433.07345,
    y: 304.75121,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 433.07345,
    y: 314.21865,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 433.07345,
    y: 309.48493,
    width: 8.3457,
    height: 0.33652
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 450.69476,
    y: 303.80896,
    width: 9.42755,
    height: 16.42219
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 451.23569,
    y: 304.75121,
    width: 8.3457,
    height: 14.53768
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.23569,
    y: 314.21865,
    width: 8.3457,
    height: 0.33652
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 451.23569,
    y: 309.48493,
    width: 8.3457,
    height: 0.33652
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 450.64717,
    y: 209.38137,
    width: 2.15373,
    height: 17.49905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.1183,
    y: 207.49686,
    width: 1.21147,
    height: 1.88451
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 344.48467,
    y: 191.54435,
    width: 62.01532,
    height: 146.79159
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 347.61843,
    y: 191.54435,
    width: 55.74782,
    height: 20.78173
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 347.61843,
    y: 215.5423,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 348.28122,
    y: 216.69684,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 348.28122,
    y: 228.29723,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 348.28122,
    y: 222.49703,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 369.87248,
    y: 215.5423,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 370.53528,
    y: 216.69684,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.53528,
    y: 228.29723,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.53528,
    y: 222.49703,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.12654,
    y: 215.5423,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 392.78934,
    y: 216.69684,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.78934,
    y: 228.29723,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.78934,
    y: 222.49703,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 347.61843,
    y: 242.37162,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 348.28122,
    y: 243.52617,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 348.28122,
    y: 255.12655,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 348.28122,
    y: 249.32636,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 369.87248,
    y: 242.37162,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 370.53528,
    y: 243.52617,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.53528,
    y: 255.12655,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.53528,
    y: 249.32636,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.12654,
    y: 242.37162,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 392.78934,
    y: 243.52617,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.78934,
    y: 255.12655,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.78934,
    y: 249.32636,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 347.61843,
    y: 269.20095,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 348.28122,
    y: 270.35549,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 348.28122,
    y: 281.95587,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 348.28122,
    y: 276.15568,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 369.87248,
    y: 269.20095,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 370.53528,
    y: 270.35549,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.53528,
    y: 281.95587,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.53528,
    y: 276.15568,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.12654,
    y: 269.20095,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 392.78934,
    y: 270.35549,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.78934,
    y: 281.95587,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.78934,
    y: 276.15568,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 347.61843,
    y: 296.03027,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 348.28122,
    y: 297.18481,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 348.28122,
    y: 308.7852,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 348.28122,
    y: 302.985,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 369.87248,
    y: 296.03027,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 370.53528,
    y: 297.18481,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.53528,
    y: 308.7852,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 370.53528,
    y: 302.985,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.12654,
    y: 296.03027,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 392.78934,
    y: 297.18481,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.78934,
    y: 308.7852,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 392.78934,
    y: 302.985,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 392.06824,
    y: 180.32881,
    width: 2.63895,
    height: 21.44147
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.64551,
    y: 178.01973,
    width: 1.48441,
    height: 2.30908
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 485.80483,
    y: 259.2055,
    width: 62.01532,
    height: 79.13043
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 488.93858,
    y: 285.64364,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 489.60138,
    y: 286.79818,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 489.60138,
    y: 298.39856,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 489.60138,
    y: 292.59837,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 511.19264,
    y: 285.64364,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 511.85543,
    y: 286.79818,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 511.85543,
    y: 298.39856,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 511.85543,
    y: 292.59837,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 533.4467,
    y: 285.64364,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 534.10949,
    y: 286.79818,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 534.10949,
    y: 298.39856,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 534.10949,
    y: 292.59837,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 488.93858,
    y: 312.47296,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 489.60138,
    y: 313.6275,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 489.60138,
    y: 325.22788,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 489.60138,
    y: 319.42769,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 511.19264,
    y: 312.47296,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 511.85543,
    y: 313.6275,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 511.85543,
    y: 325.22788,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 511.85543,
    y: 319.42769,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 533.4467,
    y: 312.47296,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 534.10949,
    y: 313.6275,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 534.10949,
    y: 325.22788,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 534.10949,
    y: 319.42769,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 488.93858,
    y: 259.2055,
    width: 55.74782,
    height: 20.78173
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 533.3884,
    y: 248.1549,
    width: 2.63895,
    height: 21.44147
  }), /*#__PURE__*/React.createElement("rect", {
    x: 533.96567,
    y: 245.84582,
    width: 1.48441,
    height: 2.30908
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 212.44515,
    y: 259.2055,
    width: 62.01532,
    height: 79.13043
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 215.5789,
    y: 285.64364,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 216.24169,
    y: 286.79818,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 216.24169,
    y: 298.39856,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 216.24169,
    y: 292.59837,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 237.83296,
    y: 285.64364,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 238.49575,
    y: 286.79818,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 238.49575,
    y: 298.39856,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 238.49575,
    y: 292.59837,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 260.08702,
    y: 285.64364,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 260.74981,
    y: 286.79818,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 260.74981,
    y: 298.39856,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 260.74981,
    y: 292.59837,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 215.5789,
    y: 312.47296,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 216.24169,
    y: 313.6275,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 216.24169,
    y: 325.22788,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 216.24169,
    y: 319.42769,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 237.83296,
    y: 312.47296,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 238.49575,
    y: 313.6275,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 238.49575,
    y: 325.22788,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 238.49575,
    y: 319.42769,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 260.08702,
    y: 312.47296,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 260.74981,
    y: 313.6275,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 260.74981,
    y: 325.22788,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 260.74981,
    y: 319.42769,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 215.5789,
    y: 259.2055,
    width: 55.74782,
    height: 20.78173
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 260.02871,
    y: 248.1549,
    width: 2.63895,
    height: 21.44147
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.60598,
    y: 245.84582,
    width: 1.48441,
    height: 2.30908
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 113.01827,
    y: 248.92882,
    width: 85.39477,
    height: 89.40711
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 139.07107,
    y: 274.44924,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 139.73387,
    y: 275.60379,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 139.73387,
    y: 287.20417,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 139.73387,
    y: 281.40398,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 117.33343,
    y: 274.44924,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 117.99622,
    y: 275.60379,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 117.99622,
    y: 287.20417,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 117.99622,
    y: 281.40398,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 160.80872,
    y: 274.44924,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 161.47151,
    y: 275.60379,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 161.47151,
    y: 287.20417,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 161.47151,
    y: 281.40398,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 182.54636,
    y: 274.44924,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 183.20915,
    y: 275.60379,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 183.20915,
    y: 287.20417,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 183.20915,
    y: 281.40398,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 139.07107,
    y: 299.11328,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 139.73387,
    y: 300.26782,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 139.73387,
    y: 311.8682,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 139.73387,
    y: 306.06801,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 117.33343,
    y: 299.11328,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 117.99622,
    y: 300.26782,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 117.99622,
    y: 311.8682,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 117.99622,
    y: 306.06801,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 160.80872,
    y: 299.11328,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 161.47151,
    y: 300.26782,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 161.47151,
    y: 311.8682,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 161.47151,
    y: 306.06801,
    width: 10.22593,
    height: 0.41234
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 182.54636,
    y: 299.11328,
    width: 11.55151,
    height: 20.12199
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 183.20915,
    y: 300.26782,
    width: 10.22593,
    height: 17.81291
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 183.20915,
    y: 311.8682,
    width: 10.22593,
    height: 0.41234
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 183.20915,
    y: 306.06801,
    width: 10.22593,
    height: 0.41234
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 117.33343,
    y: 248.92882,
    width: 76.76445,
    height: 20.78173
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 183.98128,
    y: 237.87822,
    width: 2.63895,
    height: 21.44147
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.55855,
    y: 235.56914,
    width: 1.48441,
    height: 2.30908
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 113.01827,
    y: 329.08693,
    width: 85.29644,
    height: 9.249
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKugelTiefeLagen);
export default __webpack_public_path__ + "static/media/kugel-tiefe-lagen.ea1bd0fe9d9f9946397ea1304a716623.svg";
export { ForwardRef as ReactComponent };